import { FC } from 'react';
import { Clock, Users, Activity } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { useUnifiedAdminMetrics } from '@/hooks/useUnifiedAdminMetrics';

export const UserEngagement: FC = () => {
  // Usar el hook de métricas unificadas
  const { data: metrics, isLoading } = useUnifiedAdminMetrics();

  if (isLoading) {
    return <Skeleton className="h-[200px] w-full" />;
  }

  if (!metrics) return null;

  // Calcular métricas de engagement basadas en los datos unificados
  const activeUsersToday = metrics.funnel.total_premium_active || 0;
  const activeUsersMonth = metrics.funnel.total_premium_active || 0;
  const averageSessionTime = 15; // Valor por defecto en minutos (no disponible en métricas unificadas)

  const stats = [
    {
      icon: Users,
      label: 'Usuarios Activos Hoy',
      value: activeUsersToday.toString(),
      color: 'text-blue-500',
      bgColor: 'bg-blue-50'
    },
    {
      icon: Activity,
      label: 'Usuarios Activos este Mes',
      value: activeUsersMonth.toString(),
      color: 'text-green-500',
      bgColor: 'bg-green-50'
    },
    {
      icon: Clock,
      label: 'Tiempo Promedio por Sesión',
      value: `${averageSessionTime} min`,
      color: 'text-purple-500',
      bgColor: 'bg-purple-50'
    }
  ];

  return (
    <div className="space-y-4">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <div 
            key={stat.label} 
            className={`flex items-center gap-4 p-5 rounded-lg ${stat.bgColor} border border-gray-100`}
          >
            <div className={`p-3 rounded-full bg-white ${stat.color} shadow-sm`}>
              <Icon className="w-6 h-6" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">{stat.label}</p>
              <p className="text-2xl font-semibold">{stat.value}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
